/*
 * @Author: hujiajun
 * @Date: 2021-03-10 10:32:35
 * @LastEditTime: 2021-06-25 15:08:48
 * @LastEditors: Do not edit
 * @FilePath: \FullPhotoViewer\src\api\api.js
 * @Description:
 */
import api from './public';

// 根据 SceneId 获取全景方案
export const GetTourBySceneId = (params) => {
    return api.get('render/Tour/GetTourBySceneId', params);
};

/**
 * 根据TourId 获取全景方案
 * @param {{tourId: string}} params
 * @returns {Promise<any>}
 */
export function GetTourById(params){
  const url = `render/Tour/GetTourById`
  return api.get(url, params)
}

// 根据任务获取单个场景
export const GetPano = (params) => {
    return api.get('render/Tour/GetPano', params);
};

/**
 * 上传图片
 * @params { string } type (2 => 缩略图)
 */
export const UploadPicture = (tokenId, fileName, type, params) => {
    return api.post('render/Tour/UploadPicture?tokenId=' + tokenId + '&fileName=' + fileName + '&type=' + type, params);
};

// 上传xml
export const CreateTour = (tokenId, fileName, type, params) => {
    return api.post('render/Tour/UploadPicture?tokenId=' + tokenId + '&fileName=' + fileName + '&type=' + type, params);
};

// 修改全景方案
export const UpdateTour = (params) => {
    return api.post('render/Tour/UpdateTour', params);
};

// 获取音乐列表
export const GetMusicList = (param) => {
    return api.get('render/Tour/GetMusicList', param);
}

// 根据scenceId获取所有全景信息
export const GetPanoGroup = (id, tokenId) => {
    return api.get('render/Tour/GetPanoGroup?sceneId=' + id + '&tokenId=' + tokenId);
}

// 获取全景列表
export const GetTaskInfosByDateAndTokenIdPage = (params) => {
    // return request({
    //     url: 'API/Project/GetTaskInfosByDateAndTokenIdPage',
    //     methods: 'get',
    //     requestBaseUrl: 'two',
    //     params: params
    // })
    let otherUrl = {
        requestBaseUrl: 'two',
    }
    return api.get('xr/GetTaskInfosByDateAndTokenIdPage', params, otherUrl);
}


// 设置常用视野
export const SaveDesignerInfoExtend = (params) => {
    return api.post('render/Tour/SaveDesignerInfoExtend', params);
};

// 获取常用视野
export const GetDesignerInfoExtend = (params) => {
    return api.get('render/Tour/GetDesignerInfoExtend', params);
}
// 获取oss配置数据
export const getUploadInfo = (params) => {
    return api.get('storage/API/getUploadInfo?tokenId='+params.tokenId + '&funcType=' + params.funcType+ '&fileType=' + params.fileType + '&fileName=' + params.fileName)
}
// 上传到obs成功之后，将上传信息保存到数据库
export function uploadInfo(data){
     return api.post('render/Tour/uploadMusic?tokenId='+ data.tokenId + '&musicName='+ data.musicName + '&url=' + data.url)
}
// 获取个人自定义音乐列表
export const getPersonalMusic = (params) => {
    return api.get('render/Tour/getPersonalMusicList',{
        tokenId:params
    })
}
// 删除自定义音乐
export const deleteMusic = (params) => {
    return api.get('render/Tour/deleteMusic?tokenId='+ params.tokenId + '&id=' + params.id)
}
// 修改歌曲名称

export const editMusicName = (params) => {
    return api.get('render/Tour/updateMusic',{
        id:params.id,
        name:params.name,
        tokenId:params.tokenId
    })
}

// 获取音乐风格
export const GetMusicStyle = (params) => {
    return api.get('render/Tour/getSysMusciStyle?tokenId='+ params.tokenId);
}

// 上传全景图增加场景
export const saveTourPersonalPanorama = (params) => {
    return api.get('render/Tour/saveTourPersonalPanorama?tokenId='+params.tokenId+'&sceneId='+params.sceneId+'&url='+params.url);
};
// 替换全景图
export const exchangeTaskRender = (params) => {
    return api.get('render/Tour/exchangeTaskRender?tokenId='+params.tokenId+'&taskId='+params.taskId+'&url='+params.url+'&previewUrl='+params.previewUrl);
};
// 查询原始全景图
export const recoverTaskRenderImage = (params) => {
    return api.get('render/Tour/recoverTaskRenderImage?tokenId='+params.tokenId+'&taskId='+params.taskId);
};
// 查看全景图是否有替换
export function checkInitialRender(tokenId, taskidArr){
    return api.post('render/Tour/checkInitialRender?tokenId='+tokenId , taskidArr)
}

// 将tokenId转化成mtdsId
export const getMtdsId = (cid) => {
    return api.get('render/Tour/getMtdsId?cid=' + cid);
};

// 获取欧派小程序
export function getQrcode({ mtdsUserId, pageUrl}){
    let headers = {
        "AppCode": "GRZX",
        "appid": "wx3713b1d8b100b0be",
        "platform": "mp-weixin",
        "SubAppCode": "GRZXMP001"
    }
    let data = {
        "page": "pages/common/h5",
        "encrypt": true,
        "appid": "wx3713b1d8b100b0be",
        "envVersion": process.env.NODE_ENV === 'development' ? "TRIAL" : "RELEASE",
        "originalScene": `mpType=userCenter&mtdsUserId=${mtdsUserId}&pageType=720&pageUrl=${pageUrl}`,
        "width": 500,
        "autoColor": false,
        "isHyaline": false,
        "lineColorR": 1,
        "lineColorG": 1,
        "lineColorB": 1,
        "envVersion": "TRIAL"
    }
    return new Promise((resolve, reject) => {
        axios.post('/appcenter/anonymous/wx/ma/qrCode/create', data, {
            headers: headers
        }).then(res => {
            resolve(res.data);
        }).catch(error => {
            reject(error);
        });
    });
}
// 获取热点列表
export const queryMouldPage = (tokenId, param) => {
    return api.post('render/Tour/queryMouldPage?tokenId='+tokenId, param);
}
// 获取热点库标签
export const getLabelTree = (tokenId) => {
    return api.get('render/TourHotspot/getLabelTree?tokenId='+tokenId);
}
// 获取商品清单(编辑页面)
export const initTourProductList = (params) => {
    return api.get('render/Tour/initTourProductList?tokenId=' + params.tokenId + '&tourId=' + params.tourId + '&taskId=' + params.taskId);
}
// 根据商品Id获取商品对应的信息
export const getTourHotspotMouldById = (params) => {
    return api.get('render/Tour/getTourHotspotMouldById?tokenId=' + params.tokenId + '&id=' + params.id);
}
// 保存用户编辑好的热点信息
export const savePersonalTourProductHotspot = (tokenId, params) => {
    return api.post('render/Tour/savePersonalTourProductHotspot?tokenId=' + tokenId, params);
}
// 保存用户编辑好的热点信息(直接从模版库获取的信息)
export const saveTourHotspotFromMould = (tokenId, params) => {
    return api.post('render/Tour/saveTourHotspotFromMould?tokenId=' + tokenId, params);
}
// 控制商品是否显示，热点是否显示
export const updateTourProductShowStatus = (tokenId, params) => {
    return api.post('render/Tour/updateTourProductShowStatus?tokenId=' + tokenId, params);
}
// 获取商品清单(预览页面)
export const getTourProductList = (params) => {
    return api.get('render/Tour/getTourProductList?taskId=' + params.taskId + '&tourId=' + params.tourId);
}

// 下载全景图
export const getPreviewImage = (params) => {
    return api.get('render/Tour/getPreviewImage', params);
};

// 获取全景的xml内容，也是全景pano获取xml接口
export const GetTourByTaskId = (params) => {
    return api.get('render/Tour/GetTourByTaskId', params);
};

// 获取用户权益接口
export const getAccountAbilityExtend = (params) =>  {
    return api.get('render/taskRender/'+ params.Cid +'/getAccountAbilityExtend?tokenId=' + params.tokenId)
}

// 上传视频后，将视频格式再进行转换
export const convertVideoCodec = (params) =>  {
    // return api.get('render/Tour/convertVideoCodec?url=' + params.url + '&tokenId=' + params.tokenId)
    return api.get('render/Tour/convertVideoCodec', params)
}

// 查询视频转换进度
export const getConvertVideoList = (params) =>  {
    return api.get('render/Tour/getConvertVideoList', params)
}



// WEBPACK FOOTER //
// ./src/api/api.js